import { httpUserElo } from "api/admin/user";
import { useQuery } from "react-query";
import {
  Card,
  EmptyState,
  ErrorState,
  LoadingRows,
  formatDate,
  formatLabel,
} from "../access-control/components";
export default function UserGamification({ userID }: { userID: number }) {
  const query = useQuery(["user-elo", userID], () => httpUserElo(userID), {
    retry: false,
  });
  if (query.isError)
    return <ErrorState error={query.error} retry={query.refetch} />;
  if (query.isLoading || !query.data) return <LoadingRows />;
  const { standing, recentAwards } = query.data;
  return (
    <div className="space-y-5">
      <Card title="ELO standing">
        <dl className="p-5 space-y-3 text-sm">
          <dt>Total points</dt>
          <dd className="text-xl font-semibold">{standing.totalPoints}</dd>
          <dt>Current tier</dt>
          <dd>{standing.tier?.name || "No tier"}</dd>
          <dt>Next tier</dt>
          <dd>
            {standing.nextTier
              ? `${standing.nextTier.name} · ${standing.nextTier.lowerLimit} points`
              : "No higher tier"}
          </dd>
          <dt>Standing</dt>
          <dd>{formatLabel(standing.risk.state)}</dd>
          <dt>Points to maintain tier</dt>
          <dd>{standing.risk.pointsToMaintainTier}</dd>
          {standing.risk.deadlineAt && (
            <>
              <dt>Deadline</dt>
              <dd>{formatDate(standing.risk.deadlineAt)}</dd>
            </>
          )}
        </dl>
      </Card>
      <Card title="Recent ELO awards">
        {!recentAwards.length ? (
          <EmptyState
            title="No awards"
            body="Recent ELO awards will appear here."
          />
        ) : (
          <ul className="divide-y">
            {recentAwards.map((award) => (
              <li className="p-4 text-sm" key={award.id}>
                <b>{award.points} points</b> · {formatLabel(award.eloCategory)}
                <p className="mt-1 text-gray-500 break-words">
                  {formatLabel(award.sourceType)} · {award.sourceId}
                </p>
              </li>
            ))}
          </ul>
        )}
      </Card>
    </div>
  );
}
